import { useContext, useEffect, useMemo, useState } from "react";
import { RightsHolderBandViewModel } from "../../../generated/data-contracts";
import { RightsHolderType } from "../../../models";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { ForbiddenPage } from "../../shared/error/ForbiddenPage";
import { BandsGrid } from "./BandsGrid";
import { SubmitBand } from "./submitBand/SubmitBand";

export function BandsPage() {
  const { ctxRightsHolder, res } = useContext(AvisContext);
  const [initGridData, setInitGridData] = useState<
    RightsHolderBandViewModel[] | undefined
  >();
  const [isGridLoading, setIsGridLoading] = useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();

  const hasRights = useMemo(() => {
    if (!ctxRightsHolder?.rightsHolderTypeCode) return false;

    return ctxRightsHolder?.rightsHolderTypeCode !== RightsHolderType.Publisher;
  }, [ctxRightsHolder?.rightsHolderTypeCode]);

  const getGridData = () => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    if (!isGridLoading) setIsGridLoading(true);

    api
      .rightsHoldersGetBandsByRightsHolderId(ctxRightsHolder.rightsHolderId)
      .then((res) => setInitGridData(res.data))
      .catch(setError)
      .finally(() => {
        setIsGridLoading(false);
      });
  };

  useEffect(() => {
    getGridData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasRights) return <ForbiddenPage showToHomePageButton />;

  return (
    <AvisForm title={res("authors_BandName_BandsTitle")}>
      <AvisDescriptiveText textKey="portal_RH_RightsHolderBands_1" />
      <SubmitBand
        rhBands={initGridData}
        onSubmit={getGridData}
        loading={isGridLoading}
      />
      <BandsGrid
        initGridData={initGridData}
        error={error}
        isGridLoading={isGridLoading}
      />
    </AvisForm>
  );
}
